/**
   * Wrap an <img> in an <a> tag suitable for GLightbox.
   * Safe to call multiple times; won’t double-wrap.
   */
function ensureLightboxWrap(imgEl, href, title) {
    // Already wrapped?
    const existing = imgEl.closest('a.glightbox-cartoon');
    if (existing) {
        existing.href = href; // keep href in sync
        if (title) existing.setAttribute('data-title', title);
        return;
    }

    const a = document.createElement('a');
    a.href = href;
    a.className = 'glightbox-cartoon'; // use a specific selector for this gallery
    a.setAttribute('data-gallery', 'cartoon-puzzle');
    if (title) a.setAttribute('data-title', title);

    // Insert <a> before the image and move the image inside it
    imgEl.parentNode.insertBefore(a, imgEl);
    a.appendChild(imgEl);
}